import React from 'react';
import { motion } from 'framer-motion';
import * as Icons from 'lucide-react';
import { solutions } from '../mock';

export const Solutions = () => {
  const getIcon = (iconName) => {
    const iconMap = {
      'heart-pulse': Icons.HeartPulse,
      'building-2': Icons.Building2,
      'shopping-cart': Icons.ShoppingCart,
      'factory': Icons.Factory,
      'graduation-cap': Icons.GraduationCap,
      'landmark': Icons.Landmark
    };
    return iconMap[iconName] || Icons.Briefcase;
  };

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.15
      }
    }
  };

  const cardVariants = {
    hidden: { opacity: 0, scale: 0.8 },
    visible: {
      opacity: 1,
      scale: 1,
      transition: { duration: 0.5 }
    }
  };

  return (
    <section id="solutions" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="text-center space-y-4 mb-16"
        >
          <span className="inline-block px-4 py-2 bg-[#2196F3]/10 text-[#2196F3] rounded-full text-sm font-semibold">
            Industry Solutions
          </span>
          <h2 className="text-4xl md:text-5xl font-bold text-[#071B4D]">
            Tailored Solutions for Every Industry
          </h2>
          <p className="max-w-3xl mx-auto text-lg text-gray-600">
            Deep domain expertise across multiple sectors, delivering specialized
            solutions that address unique industry challenges.
          </p>
        </motion.div>

        <motion.div
          variants={containerVariants}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, margin: "-50px" }}
          className="grid md:grid-cols-2 lg:grid-cols-3 gap-8"
        >
          {solutions.map((solution) => {
            const IconComponent = getIcon(solution.icon);
            return (
              <motion.div
                key={solution.id}
                variants={cardVariants}
                whileHover={{ y: -10 }}
                className="group relative p-8 bg-white rounded-2xl border-2 border-gray-200 hover:border-[#2196F3] transition-all duration-300 shadow-lg hover:shadow-2xl overflow-hidden"
              >
                {/* Animated Background */}
                <motion.div
                  className="absolute inset-0 bg-gradient-to-br from-[#2196F3]/0 to-[#071B4D]/0 group-hover:from-[#2196F3]/5 group-hover:to-[#071B4D]/5 transition-all duration-500"
                />

                <div className="relative space-y-4">
                  <div className="w-16 h-16 bg-gradient-to-br from-[#2196F3]/10 to-[#071B4D]/10 rounded-2xl flex items-center justify-center group-hover:scale-110 group-hover:rotate-6 transition-all duration-300">
                    <IconComponent className="w-8 h-8 text-[#2196F3]" />
                  </div>
                  <h3 className="text-2xl font-bold text-[#071B4D]">
                    {solution.industry}
                  </h3>
                  <p className="text-gray-600 leading-relaxed">
                    {solution.description}
                  </p>
                </div>
              </motion.div>
            );
          })}
        </motion.div>
      </div>
    </section>
  );
};